import React, { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "../../../component/table/Table";
import { orderTableColumnsConfig } from "./orderTableColumnsConfig";

export const OrderTablePage = ({ data }) => {
  const navigate = useNavigate();

  // Navigate to order detail page
  const handleNavigateToDetail = useCallback(
    (orderId) => {
      navigate(`/orders/${orderId}`);
    },
    [navigate]
  );

  // Column definitions for table
  const columnDefs = useMemo(
    () => orderTableColumnsConfig(handleNavigateToDetail),
    [handleNavigateToDetail]
  );

  return <Table data={data} columns={columnDefs} />;
};
